import { makeAutoObservable } from "mobx";

interface ISnackbarOptions {
  message: string;
  variant: "success" | "error";
}

export class SnackbarStore {
  isOpen = false;

  options: ISnackbarOptions | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  open(options: ISnackbarOptions) {
    this.isOpen = true;
    this.options = options;
  }

  close() {
    this.isOpen = false;
    setTimeout(() => {
      this.options = null;
    }, 500);
  }

  reset() {
    this.isOpen = false;
    this.options = null;
  }
}
